import {IVanillaReaderPublicationData} from '../VanillaReader/VanillaReaderModel';
import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IVanillaReaderUiComponentController} from './IVanillaReaderUiComponentController';
import {VanillaReaderUI} from './VanillaReaderUI';
import {VanillaReaderAPI} from "../VanillaReaderAPI/VanillaReaderAPI";

export interface VanillaReaderUiDialogOpenFileController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}

/**
 * # VanillaReaderUiDialogOpenFileController
 *
 * ## RESPONSIBILITIES
 * This controller mixin class handles all event callbacks from the `VanillaReaderUiDialogOpenFile` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogOpenFile
 * - VanillaReaderShelfItem
 *
 */

export class VanillaReaderUiDialogOpenFileController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogOpenFile.onBookshelfItemsRendered(vanillaReaderUiContext._onBookshelfItemsRendered.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onFileSelected(vanillaReaderUiContext._onDialogOpenFileSelected.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onFileListItemClicked(vanillaReaderUiContext._onDialogOpenFileOpenUrl.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onShelfListItemClicked(vanillaReaderUiContext._onDialogOpenFileOpenShelfItem.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onFileListItemDeletePublicationResourcesButtonClicked(vanillaReaderUiContext._onDialogOpenFilePublicationResourcesDeleteButtonClicked.bind(vanillaReaderUiContext));
    }

    _onDialogOpenFileSelected(fileObject: File): void {
        let storeOnDevice = this.useDeviceStorage; // If we run as a Progressive Web App we can store the downloaded data for offline reading.
        VanillaReaderAPI.instance?.loadPublicationFromFile(fileObject, undefined, storeOnDevice);
        this.toaster.toast(`Opening ${fileObject.name}`).catch(console.warn);

    };

    _onDialogOpenFileOpenShelfItem(shelfItemData: IVanillaReaderPublicationData): void {
        VanillaReaderAPI.instance?.loadPublicationFromShelfItemData(shelfItemData);
        this.toaster.toast(`Opening ${shelfItemData.fileName}`).catch(console.warn);
    };

    _onDialogOpenFileOpenUrl(fileUrl: string): void {
        // We should really use the url here as the file name is not guaranteed to be unique.
        let fileName = fileUrl.slice(fileUrl.lastIndexOf('/') + 1);
        // If we run as a Progressive Web App we can store the downloaded data for offline reading.
        let storeOnDevice = this.useDeviceStorage;
        VanillaReaderAPI.instance?.loadPublicationFromUrl(fileUrl, undefined, storeOnDevice);

        this.toaster.toast(`Opening ${fileName}`).catch(console.warn);

    };

    _onDialogOpenFilePublicationResourcesDeleteButtonClicked(shelfItemData: IVanillaReaderPublicationData): void {
        if (window.confirm(`Are you sure you want to remove "${shelfItemData.title}", including all bookmarks and annotations?`)) {
            VanillaReaderAPI.instance?.deletePublicationResources(shelfItemData);
        }
    };

    _onBookshelfItemsRendered(): void {
        //console.log('_onBookshelfItemsRendered');
    }

}
